module.exports = __webpack_public_path__ + "img/download-icon.12edfca7.svg";